import {utils} from "./utils";

const navMenu = document.getElementById('menu-navigazione');

//================================= TOGGLE MENU
const body = document.querySelector('body');
const menuToggle = document.getElementById('menu-toggle');

document.addEventListener('click', function (e) {

	// check if menuToggle exists
	if (menuToggle === null)
	{
		return;
	}

	// return if the clicked element is not #menu-toggle nor is contained in #menu-toggle
	if (e.target !== menuToggle && !menuToggle.contains(e.target))
	{
		return;
	}

	menuToggle.classList.toggle('tcon-transform');

	// open/close mobile menu
	body.classList.toggle('menu-open');

	// toggle page scrolling
	if (body.classList.contains('menu-open'))
	{
		document.body.setAttribute("data-lenis-prevent", "true");
	}
	else
	{
		document.body.removeAttribute("data-lenis-prevent");

	}

	/*let toggleLabel = menuToggle.querySelector('.tcon-label');

	if (toggleLabel !== null)
	{
		toggleLabel.textContent = (body.classList.contains('menu-open')) ? toggleLabel.dataset.labelClose : toggleLabel.dataset.labelMenu;
	}*/
});

let menuClose = document.querySelector('#menu-close');

if (menuClose !== null)
{
	menuClose.addEventListener('click', function () {
		// close mobile menu
		body.classList.remove('menu-open');

		// allow page scrolling
		document.body.removeAttribute("data-lenis-prevent");
	});
}


//================================= ADD SUB-MENU TOGGLES

document.querySelectorAll('.menu-item-has-children > a').forEach((el) => {
	const toggleMenuItem = document.createElement('span');
	toggleMenuItem.classList.add('toggle_menu_item');
	el.appendChild(toggleMenuItem);

	const menuItem = el.closest('.menu-item');

	toggleMenuItem.addEventListener('click', function(e){
		e.preventDefault();
		e.stopPropagation();

		utils.toggleClasses(menuItem, 'open');
		utils.toggleClasses(navMenu.parentNode, 'sub-menu-open');
		navMenu.parentNode.dataset.menuOpen = menuItem.id;
		//utils.slideToggle(menuItem.querySelector('.sub-menu'));
	});
});


//================================= KEYBOARD NAVIGATION

document.querySelectorAll('.sub-menu').forEach((el) => {
	const menuItem = el.closest('.menu-item');

	// open submenu when one of his children is in focus
	el.addEventListener('focusin', function(e) {

		if (e.currentTarget.contains(e.relatedTarget)) {
			/* Focus was already in the container */
		} else {
			/* Focus was received from outside the container */
		}

		menuItem.classList.add('open');
		navMenu.parentNode.classList.add('sub-menu-open');

		// reset navMenu position (keyboard navigation tries to move sub menus into the viewport even if overflow = hidden)
		navMenu.scrollTo({
			left: 0,
			behavior: "instant",
		});
	});

	// close submenu when it loses focus
	el.addEventListener('focusout', function(e) {

		if (e.currentTarget.contains(e.relatedTarget)) {
			/* Focus will still be within the container */
		} else {
			/* Focus will leave the container */
			menuItem.classList.remove('open');
			navMenu.parentNode.classList.remove('sub-menu-open');
		}
	});
});